export default class Address {
  public postcode: string = '';

  public buildingName: string = '';

  public buildingNumber: string = '';

  public subBuildingName: string = '';

  public street: string = '';

  public dependentLocality: string = '';

  public town: string = '';

  public subStreet: string = '';

  public organisationName: string = '';

  public subNationalArea: string = ''; // e.g. England

  public country: string = 'United Kingdom';

  public latitude: number = 0;

  public longitude: number = 0;
}
